/**
 * Opt-in marker for Monday-first weeks. Passed as `weekStartsOn` in search filter variables so
 * the shared period builders can keep their Sunday default for every other surface.
 */
export const WEEK_STARTS_ON_MONDAY = 'monday'

/**
 * ISO 8601 week: Monday–Sunday. Used by the meetings page date presets (SA-4357); other
 * surfaces keep the US Sunday–Saturday window from `startOfUsWeekSunday`.
 *
 * Luxon's DateTime#startOf('week') is already ISO (Monday), unlike moment's locale-driven
 * startOf('week'). Named here so call sites read as an explicit choice, not a default.
 *
 * @param {import('@calendly/datetime').DateTime} dt
 */
export const startOfIsoWeekMonday = (dt) => dt.startOf('week').startOf('day')
